// const OFFENSIVE_RATE_STAT_DETAIL_DICT = {
//   'totals_type': 'number',
//   'per_100_poss_type': 'decimal',
//   'per_game_type': 'decimal',
//   'per_100_poss_denominator': 'OffPoss',
//   'per_game_denominator': 'GamesPlayed'
// };

// const DEFENSIVE_RATE_STAT_DETAIL_DICT = {
//   'totals_type': 'number',
//   'per_100_poss_type': 'decimal',
//   'per_game_type': 'decimal',
//   'per_100_poss_denominator': 'DefPoss',
//   'per_game_denominator': 'GamesPlayed'
// };

// const TOTAL_RATE_STAT_DETAIL_DICT = {
//   'totals_type': 'number',
//   'per_100_poss_type': 'decimal',
//   'per_game_type': 'decimal',
//   'per_100_poss_denominator': 'TotalPoss',
//   'per_game_denominator': 'GamesPlayed'
// };

// const PENALTY_RATE_STAT_DETAIL_DICT = {
//   'totals_type': 'number',
//   'per_100_poss_type': 'decimal',
//   'per_game_type': 'decimal',
//   'per_100_poss_denominator': 'PenaltyOffPoss',
//   'per_game_denominator': 'GamesPlayed'
// };

// const NON_TAKE_PENALTY_RATE_STAT_DETAIL_DICT = {
//   'totals_type': 'number',
//   'per_100_poss_type': 'decimal',
//   'per_game_type': 'decimal',
//   'per_100_poss_denominator': 'PenaltyOffPossExcludingTakeFouls',
//   'per_game_denominator': 'GamesPlayed'
// };

// const RATE_STAT_DETAILS = {
//   '2pt And 1 Free Throw Trips': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   '3SecondViolations': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   '3pt And 1 Free Throw Trips': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Arc3Assists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Arc3FGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Arc3FGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'AssistPoints': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Assisted2s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Assisted3s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Assists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'AtRimAssists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'AtRimFGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'AtRimFGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Away From Play Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BadPassOutOfBoundsTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BadPassTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Blocked2s': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Blocked3s': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockedArc3': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockedAtRim': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockedCorner3': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockedLongMidRange': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockedShortMidRange': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockingFouls': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'BlockingFoulsDrawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Blocks': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Charge Fouls': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Charge Fouls Drawn': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Clear Path Fouls': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Clear Path Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Corner3Assists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Corner3FGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Corner3FGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'DeadBallTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'DefRebounds': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'DefThreePtRebounds': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'DefTwoPtRebounds': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Defensive 3 Seconds Violations': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'DefensiveGoaltends': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Double Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FG2A': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FG2M': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FG3A': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FG3M': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FTA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FTDefRebounds': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FTOffRebounds': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Fg2aBlocked': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Fg3aBlocked': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FirstChancePoints': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Flagrant 1 Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Flagrant 2 Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Fouls': TOTAL_RATE_STAT_DETAIL_DICT,
//   'FoulsDrawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'FtPoints': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Inbound Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'LiveBallTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'LongMidRangeAssists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'LongMidRangeFGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'LongMidRangeFGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Loose Ball Fouls': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Loose Ball Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'LostBallOutOfBoundsTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'LostBallTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'NonShootingFoulsDrawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'OffRebounds': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'OffThreePtRebounds': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'OffTwoPtRebounds': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Offensive Fouls': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Offensive Fouls Drawn': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'OffensiveGoaltends': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PenaltyArc3FGA': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyArc3FGM': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyAtRimFGA': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyAtRimFGM': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyCorner3FGA': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyCorner3FGM': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyFG2A': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyFG2M': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyFG3A': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyFG3M': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyFtPoints': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyPoints': PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyPointsExcludingTakeFouls': NON_TAKE_PENALTY_RATE_STAT_DETAIL_DICT,
//   'PenaltyTurnovers': PENALTY_RATE_STAT_DETAIL_DICT,
//   'Personal Block Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Personal Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Personal Take Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PlusMinus': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Points': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PtsAssisted2s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PtsAssisted3s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PtsPutbacks': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PtsUnassisted2s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'PtsUnassisted3s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Rebounds': TOTAL_RATE_STAT_DETAIL_DICT,
//   'RecoveredBlocks': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceArc3FGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceArc3FGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceAtRimFGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceAtRimFGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceCorner3FGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceCorner3FGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceFG2A': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceFG2M': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceFG3A': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceFG3M': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceFtPoints': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceOffPoss': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChancePoints': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'SecondChanceTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Shooting Block Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Shooting Fouls Drawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'ShootingFouls': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'ShortMidRangeAssists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'ShortMidRangeFGA': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'ShortMidRangeFGM': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Steals': DEFENSIVE_RATE_STAT_DETAIL_DICT,
//   'StepOutOfBoundsTurnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Technical Free Throws Trips': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'ThreePtAssists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'ThreePtShootingFoulsDrawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Travels': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Turnovers': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'TwoPtAssists': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'TwoPtShootingFoulsDrawn': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Unassisted2s': OFFENSIVE_RATE_STAT_DETAIL_DICT,
//   'Unassisted3s': OFFENSIVE_RATE_STAT_DETAIL_DICT
// };

export const rateStats = {
  data () {
    return {
      offensive_rate_stats: {
        'totals_type': 'number',
        'per_100_poss_type': 'decimal',
        'per_game_type': 'decimal',
        'per_100_poss_denominator': 'OffPoss',
        'per_game_denominator': 'GamesPlayed'
      },
      defensive_rate_stats: {
        'totals_type': 'number',
        'per_100_poss_type': 'decimal',
        'per_game_type': 'decimal',
        'per_100_poss_denominator': 'DefPoss',
        'per_game_denominator': 'GamesPlayed'
      },
      totals_rate_stats: {
        'totals_type': 'number',
        'per_100_poss_type': 'decimal',
        'per_game_type': 'decimal',
        'per_100_poss_denominator': 'TotalPoss',
        'per_game_denominator': 'GamesPlayed'
      },
      penalty_rate_stats: {
        'totals_type': 'number',
        'per_100_poss_type': 'decimal',
        'per_game_type': 'decimal',
        'per_100_poss_denominator': 'PenaltyOffPoss',
        'per_game_denominator': 'GamesPlayed'
      },
      non_take_penalty_rate_stats: {
        'totals_type': 'number',
        'per_100_poss_type': 'decimal',
        'per_game_type': 'decimal',
        'per_100_poss_denominator': 'PenaltyOffPossExcludingTakeFouls',
        'per_game_denominator': 'GamesPlayed'
      }
    }
  },
  created () {
    this.rate_stat_details = {
      '2pt And 1 Free Throw Trips': this.offensive_rate_stats,
      '3SecondViolations': this.offensive_rate_stats,
      '3pt And 1 Free Throw Trips': this.offensive_rate_stats,
      'Arc3Assists': this.offensive_rate_stats,
      'Arc3FGA': this.offensive_rate_stats,
      'Arc3FGM': this.offensive_rate_stats,
      'AssistPoints': this.offensive_rate_stats,
      'Assisted2s': this.offensive_rate_stats,
      'Assisted3s': this.offensive_rate_stats,
      'Assists': this.offensive_rate_stats,
      'AtRimAssists': this.offensive_rate_stats,
      'AtRimFGA': this.offensive_rate_stats,
      'AtRimFGM': this.offensive_rate_stats,
      'Away From Play Fouls Drawn': this.offensive_rate_stats,
      'BadPassOutOfBoundsTurnovers': this.offensive_rate_stats,
      'BadPassTurnovers': this.offensive_rate_stats,
      'Blocked2s': this.defensive_rate_stats,
      'Blocked3s': this.defensive_rate_stats,
      'BlockedArc3': this.defensive_rate_stats,
      'BlockedAtRim': this.defensive_rate_stats,
      'BlockedCorner3': this.defensive_rate_stats,
      'BlockedLongMidRange': this.defensive_rate_stats,
      'BlockedShortMidRange': this.defensive_rate_stats,
      'BlockingFouls': this.defensive_rate_stats,
      'BlockingFoulsDrawn': this.offensive_rate_stats,
      'Blocks': this.defensive_rate_stats,
      'Charge Fouls': this.offensive_rate_stats,
      'Charge Fouls Drawn': this.defensive_rate_stats,
      'Clear Path Fouls': this.defensive_rate_stats,
      'Clear Path Fouls Drawn': this.offensive_rate_stats,
      'Transition Take Fouls': this.defensive_rate_stats,
      'Corner3Assists': this.offensive_rate_stats,
      'Corner3FGA': this.offensive_rate_stats,
      'Corner3FGM': this.offensive_rate_stats,
      'DeadBallTurnovers': this.offensive_rate_stats,
      'DefRebounds': this.defensive_rate_stats,
      'DefThreePtRebounds': this.defensive_rate_stats,
      'DefTwoPtRebounds': this.defensive_rate_stats,
      'Defensive 3 Seconds Violations': this.defensive_rate_stats,
      'DefensiveGoaltends': this.defensive_rate_stats,
      'Double Fouls Drawn': this.offensive_rate_stats,
      'FG2A': this.offensive_rate_stats,
      'FG2M': this.offensive_rate_stats,
      'FG3A': this.offensive_rate_stats,
      'FG3M': this.offensive_rate_stats,
      'FTA': this.offensive_rate_stats,
      'FTDefRebounds': this.defensive_rate_stats,
      'FTOffRebounds': this.offensive_rate_stats,
      'Fg2aBlocked': this.offensive_rate_stats,
      'Fg3aBlocked': this.offensive_rate_stats,
      'FirstChancePoints': this.offensive_rate_stats,
      'Flagrant 1 Fouls Drawn': this.offensive_rate_stats,
      'Flagrant 2 Fouls Drawn': this.offensive_rate_stats,
      'Fouls': this.totals_rate_stats,
      'FoulsDrawn': this.offensive_rate_stats,
      'FtPoints': this.offensive_rate_stats,
      'Inbound Fouls Drawn': this.offensive_rate_stats,
      'LiveBallTurnovers': this.offensive_rate_stats,
      'LongMidRangeAssists': this.offensive_rate_stats,
      'LongMidRangeFGA': this.offensive_rate_stats,
      'LongMidRangeFGM': this.offensive_rate_stats,
      'Loose Ball Fouls': this.defensive_rate_stats,
      'Loose Ball Fouls Drawn': this.offensive_rate_stats,
      'Transition Take Fouls Drawn': this.offensive_rate_stats,
      'LostBallOutOfBoundsTurnovers': this.offensive_rate_stats,
      'LostBallTurnovers': this.offensive_rate_stats,
      'NonShootingFoulsDrawn': this.offensive_rate_stats,
      'OffRebounds': this.offensive_rate_stats,
      'OffThreePtRebounds': this.offensive_rate_stats,
      'OffTwoPtRebounds': this.offensive_rate_stats,
      'Offensive Fouls': this.offensive_rate_stats,
      'Offensive Fouls Drawn': this.defensive_rate_stats,
      'OffensiveGoaltends': this.offensive_rate_stats,
      'PenaltyArc3FGA': this.penalty_rate_stats,
      'PenaltyArc3FGM': this.penalty_rate_stats,
      'PenaltyAtRimFGA': this.penalty_rate_stats,
      'PenaltyAtRimFGM': this.penalty_rate_stats,
      'PenaltyCorner3FGA': this.penalty_rate_stats,
      'PenaltyCorner3FGM': this.penalty_rate_stats,
      'PenaltyFG2A': this.penalty_rate_stats,
      'PenaltyFG2M': this.penalty_rate_stats,
      'PenaltyFG3A': this.penalty_rate_stats,
      'PenaltyFG3M': this.penalty_rate_stats,
      'PenaltyFtPoints': this.penalty_rate_stats,
      'PenaltyPoints': this.penalty_rate_stats,
      'PenaltyPointsExcludingTakeFouls': this.non_take_penalty_rate_stats,
      'PenaltyTurnovers': this.penalty_rate_stats,
      'Personal Block Fouls Drawn': this.offensive_rate_stats,
      'Personal Fouls Drawn': this.offensive_rate_stats,
      'Personal Take Fouls Drawn': this.offensive_rate_stats,
      'PlusMinus': this.offensive_rate_stats,
      'Points': this.offensive_rate_stats,
      'PtsAssisted2s': this.offensive_rate_stats,
      'PtsAssisted3s': this.offensive_rate_stats,
      'PtsPutbacks': this.offensive_rate_stats,
      'PtsUnassisted2s': this.offensive_rate_stats,
      'PtsUnassisted3s': this.offensive_rate_stats,
      'Rebounds': this.totals_rate_stats,
      'RecoveredBlocks': this.defensive_rate_stats,
      'SecondChanceArc3FGA': this.offensive_rate_stats,
      'SecondChanceArc3FGM': this.offensive_rate_stats,
      'SecondChanceAtRimFGA': this.offensive_rate_stats,
      'SecondChanceAtRimFGM': this.offensive_rate_stats,
      'SecondChanceCorner3FGA': this.offensive_rate_stats,
      'SecondChanceCorner3FGM': this.offensive_rate_stats,
      'SecondChanceFG2A': this.offensive_rate_stats,
      'SecondChanceFG2M': this.offensive_rate_stats,
      'SecondChanceFG3A': this.offensive_rate_stats,
      'SecondChanceFG3M': this.offensive_rate_stats,
      'SecondChanceFtPoints': this.offensive_rate_stats,
      'SecondChanceOffPoss': this.offensive_rate_stats,
      'SecondChancePoints': this.offensive_rate_stats,
      'SecondChanceTurnovers': this.offensive_rate_stats,
      'Shooting Block Fouls Drawn': this.offensive_rate_stats,
      'Shooting Fouls Drawn': this.offensive_rate_stats,
      'ShootingFouls': this.defensive_rate_stats,
      'ShortMidRangeAssists': this.offensive_rate_stats,
      'ShortMidRangeFGA': this.offensive_rate_stats,
      'ShortMidRangeFGM': this.offensive_rate_stats,
      'Steals': this.defensive_rate_stats,
      'StepOutOfBoundsTurnovers': this.offensive_rate_stats,
      'Technical Free Throws Trips': this.offensive_rate_stats,
      'ThreePtAssists': this.offensive_rate_stats,
      'ThreePtShootingFoulsDrawn': this.offensive_rate_stats,
      'Travels': this.offensive_rate_stats,
      'Turnovers': this.offensive_rate_stats,
      'TwoPtAssists': this.offensive_rate_stats,
      'TwoPtShootingFoulsDrawn': this.offensive_rate_stats,
      'Unassisted2s': this.offensive_rate_stats,
      'Unassisted3s': this.offensive_rate_stats
    }
  },
  methods: {
    convertRowToPer100Possessions (stats) {
      var rateStatKeys = Object.keys(this.rate_stat_details)
      var statKeys = Object.keys(stats)
      var per100Stats = {}
      statKeys.forEach((key) => {
        if (rateStatKeys.indexOf(key) > -1) {
          if (key === 'PlusMinus') {
            var ortg = 100 * (stats['PlusMinus'] + stats['OpponentPoints']) / stats['OffPoss']
            var drtg = 100 * stats['OpponentPoints'] / stats['DefPoss']
            per100Stats[key] = ortg - drtg
          } else {
            per100Stats[key] = 100 * stats[key] / stats[this.rate_stat_details[key]['per_100_poss_denominator']]
          }
        } else {
          per100Stats[key] = stats[key]
        }
      })
      return per100Stats
    },
    convertAllRowsToPer100Possessions (tableData, tableDataOptions, columns) {
      var per100TableData = []
      tableData.forEach((row) => {
        tableDataOptions.forEach((tableDataOption) => {
          var values = this.setZerosAndSortFunction(columns[tableDataOption.id], row)
          row = values.row
          columns[tableDataOption.id] = values.columns
        })
        var per100Row = this.convertRowToPer100Possessions(row)
        per100TableData.push(per100Row)
      })
      return per100TableData
    },
    convertRowToPerGame (stats) {
      var rateStatKeys = Object.keys(this.rate_stat_details)
      var statKeys = Object.keys(stats)
      var perGameStats = {}
      statKeys.forEach((key) => {
        if (rateStatKeys.indexOf(key) > -1) {
          if (key === 'PlusMinus') {
            var ortg = (stats['PlusMinus'] + stats['OpponentPoints']) / stats['GamesPlayed']
            var drtg = stats['OpponentPoints'] / stats['GamesPlayed']
            perGameStats[key] = ortg - drtg
          } else {
            perGameStats[key] = stats[key] / stats[this.rate_stat_details[key]['per_game_denominator']]
          }
        } else {
          perGameStats[key] = stats[key]
        }
      })
      return perGameStats
    },
    convertAllRowsToPerGame (tableData, tableDataOptions, columns) {
      var perGameTableData = []
      tableData.forEach((row) => {
        tableDataOptions.forEach((tableDataOption) => {
          var values = this.setZerosAndSortFunction(columns[tableDataOption.id], row)
          row = values.row
          columns[tableDataOption.id] = values.columns
        })
        var perGameRow = this.convertRowToPerGame(row)
        perGameTableData.push(perGameRow)
      })
      return perGameTableData
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/rate_stats.js